<template>
    <button class="flex justify-center items-center gap-2 px-4 h-10 border border-[#65748A] rounded-2xl bg-body-color">
        <slot name="left-icon"></slot>
        <div v-if="$slots?.default == undefined || text != ''">
            {{ text }}
        </div>
        <slot name="default"></slot>
        <slot name="right-icon"></slot>
    </button>
</template>

<script setup>
import { defineProps, defineOptions } from "vue"

defineOptions({
    name: 'v-button'
})

defineProps({
    text: {
        type: String,
        default: ''
    }
})

</script>